import { render, staticRenderFns } from "./BrGuides.vue?vue&type=template&id=1c002d45&scoped=true"
import script from "./BrGuides.vue?vue&type=script&lang=js"
export * from "./BrGuides.vue?vue&type=script&lang=js"
import style0 from "./BrGuides.vue?vue&type=style&index=0&id=1c002d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c002d45",
  null
  
)

export default component.exports